module.exports = __webpack_public_path__ + "img/train-7.23a958c9.jpg";